<template>
  <div class="mdl-grid">
    <div class="reset-form mdl-card mdl-cell mdl-shadow--2dp">
      <div class="ga-form-title">
        <h2 class="ga-title-text">{{'login.reset.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div>{{{'login.reset.label.text' | label}}}</div>
        <validator name="loginResetValidator">
          <form novalidate>
            <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <input class="mdl-textfield__input" type="text" id="email" v-model="email" initial="off"
                     v-validate:email="['email']" @keyup="clearValidation()">
              <label class="mdl-textfield__label" for="email">{{'login.reset.label.email' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$loginResetValidator.email.email">{{'login.reset.validation.email' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="showValidation">{{validationMessage | label}}</span>
            </div>
          </form>
        </validator>
      </div>
      <div class="mdl-card__actions">
        <div class="card-grid mdl-grid">
          <div class="mdl-cell mdl-cell--8-col">
            <div class="link" v-on:click="back()")>{{'login.reset.button.back' | label}}</div>
          </div>
          <div class="mdl-cell mdl-cell--4-col">
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
              v-on:click="validate()">
              {{'login.reset.button.send' | label}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  module.exports = {
    ready: function () {
    },
    data: function () {
      return {
        email: '',
        showValidation: false,
        validationMessage: ''
      }
    },
    methods: {
      back: function () {
        this.$dispatch('back-to-login')
      },
      validate: function () {
        var self = this
        this.$validate(true, function () {
          if (self.$loginResetValidator.invalid) {
            return
          }
          self.$dispatch('reset-request', self.email)
        })
      },
      clearValidation: function () {
        this.validationMessage = ''
        this.showValidation = false
      }
    },
    events: {
      'reset-validation-fail': function (message) {
        this.validationMessage = message
        this.showValidation = true
      }
    }
  }
</script>

<style scoped>
  .reset-form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// ResetForm.vue?41e4bf4b